import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["action", "destination", "storeHint"];

  connect() {
    this.apply();
  }

  apply() {
    const action = this.actionTargets.find((target) => target.checked)?.value;
    const opensScreen = action === "open_screen";

    this.storeHintTarget.classList.toggle("hidden", action !== "open_app_store");
    this.destinationTarget.classList.toggle("hidden", !opensScreen);
    this.destinationTarget.querySelectorAll("input").forEach((field) => {
      field.disabled = !opensScreen;
    });
  }
}
